/**
 *  A dedicated Reducer for the announcements & pop-ups engine: the dashboard queue, the
 *  "All Announcements" tab feed, the archive page item and the publisher screens.
 */

const initState = {
    queue : [],          // the ordered pop-up list for this login, as the server returned it
    queueIndex : 0,      // which item is on screen; past the end = nothing to show
    queueLoaded : false,
    feed : { list: [], departments: [], page: 1, hasMore: false, loadError: false, isLoaded: false },
    instance : null,     // archive page item
    instanceError : null, // HTTP status of the last failed item fetch (404 = not visible to this user)
    manage : { list: [], loadError: false, isLoaded: false },
    lookups : null,
    reach : null,
    responses : null,    // phase 2
}

const broadcastReducers = (state = initState, action) => {

    switch(action.type) {

        case "BROADCASTS_DUE_SUCCESS":
            return {
                ...state,
                queue : Array.isArray(action.list) ? action.list : [],
                queueIndex : 0,
                queueLoaded : true
            };

        case "BROADCASTS_DUE_FAILED":
            return {
                ...state,
                queue : [],
                queueIndex : 0,
                queueLoaded : true
            };

        case "BROADCASTS_QUEUE_NEXT":
            return {
                ...state,
                queueIndex : state.queueIndex + 1
            };

        case "BROADCASTS_FEED_SUCCESS": {
            const list = Array.isArray(action.list) ? action.list : [];
            return {
                ...state,
                feed : {
                    list : action.append ? state.feed.list.concat(list) : list,
                    departments : action.append ? state.feed.departments : (Array.isArray(action.departments) ? action.departments : []),
                    page : action.page,
                    hasMore : !!action.has_more,
                    loadError : false,
                    isLoaded : true
                }
            };
        }

        case "BROADCASTS_FEED_FAILED":
            return {
                ...state,
                feed : { ...state.feed, loadError : true }
            };

        case "BROADCAST_INSTANCE_SUCCESS":
            return {
                ...state,
                instance : action.item,
                instanceError : null
            };

        case "BROADCAST_INSTANCE_FAILED":
            return {
                ...state,
                instance : null,
                instanceError : action.status
            };

        case "BROADCAST_INSTANCE_CLEAR":
            return {
                ...state,
                instance : null,
                instanceError : null
            };

        case "BROADCASTS_MANAGE_SUCCESS":
            return {
                ...state,
                manage : {
                    list : Array.isArray(action.list) ? action.list : [],
                    loadError : false,
                    isLoaded : true
                }
            };

        case "BROADCASTS_MANAGE_FAILED":
            return {
                ...state,
                manage : { ...state.manage, loadError : true }
            };

        // The manage list is newest-first: a known id is replaced in place, a new one goes first.
        case "BROADCAST_SAVED": {
            const item = action.item;
            if (!item) return state;
            const known = state.manage.list.some((x) => x.id === item.id);
            return {
                ...state,
                manage : {
                    ...state.manage,
                    list : known
                        ? state.manage.list.map((x) => (x.id === item.id ? item : x))
                        : [item].concat(state.manage.list)
                }
            };
        }

        case "BROADCAST_DELETED":
            return {
                ...state,
                manage : {
                    ...state.manage,
                    list : state.manage.list.filter((x) => x.id !== action.id)
                }
            };

        case "BROADCAST_LOOKUPS_SUCCESS":
            return {
                ...state,
                lookups : action.lookups
            };

        case "BROADCAST_REACH_SUCCESS":
            return {
                ...state,
                reach : action.reach
            };

        case "BROADCAST_REACH_FAILED":
            return {
                ...state,
                reach : null
            };

        // The responses page block (SPEC 19.5). error = HTTP status of the last failed fetch
        // (403 = not a viewer, 404 = gone), null once a fetch succeeds.
        case "BROADCAST_RESPONSES_SUCCESS":
            return {
                ...state,
                responses : { data : action.responses, error : null }
            };

        case "BROADCAST_RESPONSES_FAILED":
            return {
                ...state,
                responses : { data : null, error : action.status }
            };

        default:
            return state;
    }
}

export default broadcastReducers;
